import { parseSnippet } from '../../lib/snippet'

export function Snippet({ text }: { text: string }) {
  return (
    <>
      {parseSnippet(text).map((part, i) => (part.highlight ? <mark key={i}>{part.text}</mark> : <span key={i}>{part.text}</span>))}
    </>
  )
}
